var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-block-controls"},[_c('btn',{attrs:{"icon-left":"angle-left","size":"sm"},on:{"click":_vm.goToCreatorPage}},[_vm._v(" "+_vm._s(_vm.$t('global.app.toMainPage'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }